import { useState } from "react";
import { Divider, Grid } from "@mui/material";

import { useQuery } from "@tanstack/react-query";
import StickyHeadTable from "ui-components/tables/StickyTable";
import TimelineList from "ui-components/Timeline/TimelineList";
import TimelineItem from "ui-components/Timeline/TimelineItem";
import Drawer from "ui-components/Drawer";
import { getROLog } from "services/data.outbound.service";
import { soStatusLabel } from "layouts/views/common/enum";
import MDTypography from "components/MDTypography";
import { getSOStatusLog } from "services/data.outbound.service";

const columns = [
  { label: "SKU Code", id: "skuCode" },
  { label: "Order Quantity", id: "quantity" },
  { label: "Base UOM", id: "baseUOM" },
  { label: "Return Quantity", id: "scannedQuantity" },
  { label: "Return Date", id: "returnDate" },
  { label: "Status", id: "status" },
];

function ReturnLog({ open, setOpen, logRequest, setLogRequest }) {
  //const onError = (data) => setAlert(<Error data={data} onChange={setAlert} />);

  const [logs, setLogs] = useState(null);

  useQuery({
    queryKey: ["ro-log", { logRequest }],
    queryFn: () => getROLog(logRequest),
    enabled: logRequest !== null,
    onSuccess: (data) => {
      //console.log(data.data.data,"data return from log");
      const item = data.data.data;

      // const renderTimelineItems = item.logs.map(({ id, ...log }) => (
      //   <TimelineItem key={id} {...log} />
      // ));
      setLogs(
        <>
          <div style={{ fontSize: "14px", marginBottom: "20px" }}>
            <Grid container>
              <Grid item xs={3}>
                <b>Customer Code : </b>
                {item.customerCode}
              </Grid>
              <Grid item xs={3}>
                <b>Customer Order Number : </b>
                {item.custOrdNbr}
              </Grid>
              <Grid item xs={3}>
                <b>Order Number : </b>
                {item.orderNumber}
              </Grid>

              <Grid item xs={3}>
                <b>Warehouse Code : </b>
                {item.warehouseCode}
              </Grid>
              <Grid item xs={3}>
                <b>Total Amount : </b>
                {item.currencyCode} {item.totalAmount}
              </Grid>
              <Grid item xs={3}>
                <b>Order Date : </b>
                {item.orderDate}
              </Grid>
              <Grid item xs={3}>
                <b>Ship Date : </b>
                {item.shipDate}
              </Grid>
            </Grid>
            <MDTypography variant="h5" color="info">
              Shipping
            </MDTypography>
            <Divider sx={{ margin: "5px 0", background: "#9ebeeb", opacity: "unset" }} />
            <Grid container>
              <Grid item xs={3}>
                <b>Ship Company : </b>
                {item.shipCompany}
              </Grid>
              <Grid item xs={9}>
                <b>Ship Address 1 : </b>
                {item.shipAddress1}
              </Grid>
              <Grid item xs={3}>
                <b>Ship Contact : </b>
                {item.shipContact}
              </Grid>
              <Grid item xs={3}>
                <b>Ship Postcode : </b>
                {item.shipPostcode}
              </Grid>
              <Grid item xs={3}>
                <b>Ship City : </b>
                {item.shipCity}
              </Grid>
              <Grid item xs={3}>
                <b>Ship State </b>
                {item.shipState}
              </Grid>
              <Grid item xs={3}>
                <b>Ship Phone :</b>
                {item.shipPhone}
              </Grid>
              <Grid item xs={3}>
                <b>Ship Country : </b>
                {item.shipCountry}
              </Grid>
            </Grid>
            <MDTypography variant="h5" color="info">
              Carrier
            </MDTypography>
            <Divider sx={{ margin: "5px 0", background: "#9ebeeb", opacity: "unset" }} />
            <Grid container>
              <Grid item xs={12/5}>
                <b>Shipping Zone : </b>
                {item.shippingZone}
              </Grid>
              <Grid item xs={12/5}>
                <b>Shipment Type : </b>
                {item.shipmentType}
              </Grid>
              <Grid item xs={12/5}>
                <b>Carrier </b>
                {item.carrier}
              </Grid>
              <Grid item xs={12/5}>
                <b>Reference No :</b>
                {item.referenceNo}
              </Grid>
              <Grid item xs={12/5}>
                <b>Marketplace : </b>
                {item.salesRepName}
              </Grid>
            </Grid>
          </div>
          <div>
            <StickyHeadTable
              columns={columns}
              rows={item.dodetails.map((x) => ({ ...x, status: soStatusLabel[x.status] }))}
            />
          </div>
          {/* <TimelineList title="Logs">{renderTimelineItems}</TimelineList> */}
        </>
      );
      //setLogRequest({ coNumber: "", custCode: "" });
    },
    //onError,
  });

  const { data } = useQuery({
    queryKey: ["so-status-log", { logRequest }],
    queryFn: () => getSOStatusLog(logRequest),
    enabled: logRequest !== null,
  });
  const details = data?.data.data.map(({ id, ...log }) => <TimelineItem key={id} {...log} />);

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(open);
    setLogs(null);
    setLogRequest(null);
  };

  return (
    <Drawer width="1400px" open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
      <MDTypography variant="h5" color="info">
        Sales Order
      </MDTypography>
      <Divider sx={{ margin: "5px 0", background: "#9ebeeb", opacity: "unset" }} />
      {logs}
      <Divider />
      {Boolean(details) && details.length > 0 && (
        <TimelineList title="Order Transaction Logs">{details}</TimelineList>
      )}
    </Drawer>
  );
}

export default ReturnLog;
